// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21nml","controls":"styles_controls__3uV-D","charLimit":"styles_charLimit__24ASz","input":"styles_input__3dQfy","send":"styles_send__LdW-K"};